/**
 * Where this device remembers an account's answer to the first-sign-in sync
 * question (cloudSync's `applyConflictChoice`).
 *
 * A module of its own so account deletion can name the key without importing
 * the sync engine, which builds a Firebase client the moment it is evaluated.
 */
export function syncChoiceKey(uid: string): string {
  return `fiveout:syncChoice:${uid}`;
}
